import {http} from '@/http/index.js';

async function startWaitingSubscription(code) {
  return http.post(`/consumer/start-waiting-subscription/${code}`);
}

export {startWaitingSubscription};
